<mat-form-field appearance="fill" class="app-form-field" [ngClass]="{ 'full-width': fullWidth }">
    <mat-label *ngIf="labelT">{{ labelT | translate }}</mat-label>
    <input matInput [formControlName]="controlKey">
    <mat-hint *ngIf="hintText" align="end">{{ hintText }}</mat-hint>
    <ng-container *ngIf="prefix" [ngTemplateOutlet]="prefix" matPrefix>
        <ng-content />
    </ng-container>
    <ng-container *ngIf="suffix" [ngTemplateOutlet]="suffix" matSuffix>
        <ng-content />
    </ng-container>
    <mat-error *ngFor="let err of errorsArray; trackBy: trackBy">
        {{ displayErrorMessage(err) }}
    </mat-error>
</mat-form-field>

<!-- Usage
    <app-form-input controlKey="<key>" hintText="..." fullWidth />
        <ng-template #suffix>
            <mat-icon svgIcon="edit"></mat-icon>
        </ng-template>
        <ng-template #prefix>
            <mat-icon svgIcon="copy"></mat-icon>
        </ng-template>
    </app-form-input />
-->